/**
 * THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
 * SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
 */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

// channel: values: "desktop" | "mobile" | null (renders on both)
export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  landing: {
    name: 'landing',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "landing" */
      './pages/Home.js'
    ),
    get component() {
      if (ssr) {
        return __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home;
      }
      if (currentRouteName === 'landing') {
        return currentRouteComponent;
      }
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/path-to-pro-network',
    channel: null
  },
  network: {
    name: 'network',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "landing" */
      './pages/Home.js'
    ),
    get component() {
      if (ssr) {
        return __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home;
      }
      if (currentRouteName === 'network') {
        return currentRouteComponent;
      }
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/network',
    channel: null
  },
  main: {
    name: 'main',
    componentName: 'SlmNavigation',
    chunk: () => import(
      /* webpackChunkName: "main" */
      './components/SlmNavigation/SlmNavigation.js'
    ),
    get component() {
      if (ssr) {
        return __webpack_require__(require.resolveWeak('@cwd/src/components/SlmNavigation/SlmNavigation.js')).SlmNavigation;
      }
      if (currentRouteName === 'main') {
        return currentRouteComponent;
      }
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SlmNavigation })));
    },
    path: '/:context?/path-to-pro-network/:tab/*',
    channel: null
  }
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
